import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Dtype from "./dtype.bs.js";
import * as Int32 from "bs-platform/lib/es6/int32.js";
import * as Int64 from "bs-platform/lib/es6/int64.js";
import * as Printf from "bs-platform/lib/es6/printf.js";
import * as Stream from "bs-platform/lib/es6/stream.js";
import * as $$String from "bs-platform/lib/es6/string.js";
import * as Ndarray0 from "./ndarray0.bs.js";
import * as Nativeint from "bs-platform/lib/es6/nativeint.js";
import * as Caml_array from "bs-platform/lib/es6/caml_array.js";
import * as Caml_int32 from "bs-platform/lib/es6/caml_int32.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Caml_format from "bs-platform/lib/es6/caml_format.js";
import * as Caml_string from "bs-platform/lib/es6/caml_string.js";
import * as Typed_array from "./typed_array.bs.js";
import * as NdarrayJs from "./ndarray.js";

function create(typed_array, indices) {
  return new NdarrayJs.ndarray(typed_array, indices);
}

function of_kind(kind, indices) {
  var size = indices.length !== 0 ? $$Array.fold_left(Caml_int32.imul, 1, indices) : 0;

  switch (kind) {
    case
    /* Float32 */
    0:
      return new NdarrayJs.ndarray(Typed_array.float32array(size), indices);

    case
    /* Float64 */
    1:
      return new NdarrayJs.ndarray(Typed_array.float64array(size), indices);

    case
    /* Int8_signed */
    2:
      return new NdarrayJs.ndarray(Typed_array.int8array(size), indices);

    case
    /* Int8_unsigned */
    3:
      return new NdarrayJs.ndarray(Typed_array.uint8array(size), indices);

    case
    /* Int16_signed */
    4:
      return new NdarrayJs.ndarray(Typed_array.int16array(size), indices);

    case
    /* Int16_unsigned */
    5:
      return new NdarrayJs.ndarray(Typed_array.uint16array(size), indices);

    case
    /* Int32 */
    6:
      return new NdarrayJs.ndarray(Typed_array.int32array(size), indices);

    case
    /* Int64 */
    7:
      return new NdarrayJs.ndarray(Typed_array.int64array(size), indices);

    case
    /* Int */
    8:
      return Pervasives.failwith("of_kind: Unsupported kind: Int");

    case
    /* Nativeint */
    9:
      return Pervasives.failwith("of_kind: Unsupported kind: Nativeint");

    case
    /* Complex32 */
    10:
      return Pervasives.failwith("of_kind: Unsupported kind: Complex32");

    case
    /* Complex64 */
    11:
      return Pervasives.failwith("of_kind: Unsupported kind: Complex64");

    case
    /* Char */
    12:
      return Pervasives.failwith("of_kind: Unsupported kind: Char");
  }
}

function t(prim, prim$1, prim$2, prim$3, prim$4, prim$5, prim$6, prim$7) {
  return {
    dimension: prim,
    shape: prim$1,
    offset: prim$2,
    stride: prim$3,
    dtype: prim$4,
    size: prim$5,
    order: prim$6,
    data: prim$7
  };
}

function dimension(prim) {
  return prim.dimension;
}

function shape(prim) {
  return prim.shape;
}

function data(prim) {
  return prim.data;
}

function kind(t) {
  return Dtype.to_kind(Ndarray0.dtype(t));
}

var get = function get(t, args) {
  return t.get.apply(t, args);
};

var set = function set(t, indices, v) {
  var args = indices.slice(0);
  args.push(v);
  return t.set.apply(t, args);
};

var set_unsafe = function set_unsafe(t, indices, v) {
  indices.push(v);
  return t.set.apply(t, args);
};

var dtype = Ndarray0.dtype;

function elem_size_in_bytes(t) {
  var dtype = Ndarray0.dtype(t);

  if (dtype >= 159585247) {
    if (dtype >= 749056140) {
      if (dtype >= 911682560) {
        if (dtype < 951901561) {
          return 4;
        }
      } else if (dtype >= 787930192) {
        return 1;
      } else {
        return 8;
      }
    } else if (dtype !== 271008382) {
      if (dtype >= 695277445) {
        return 2;
      } else {
        return 1;
      }
    } else {
      return 4;
    }
  } else if (dtype >= -483486837) {
    if (dtype >= -57036806) {
      if (dtype < 86585632) {
        return 2;
      }
    } else if (dtype >= -438449797) {
      return 1;
    } else {
      return 4;
    }
  } else if (dtype >= -643932289) {
    return 8;
  }

  return Pervasives.failwith(Curry._1(Printf.sprintf(
  /* Format */
  [
  /* String_literal */
  Block.__(11, ["elem_size_in_bytes: unsupported element type: ",
  /* String */
  Block.__(2, [
  /* No_padding */
  0,
  /* End_of_format */
  0])]), "elem_size_in_bytes: unsupported element type: %s"]), Dtype.unwrap(dtype)));
}

(function (t, args) {
  return t.lo.apply(t, args);
});

(function (t, args) {
  return t.hi.apply(t, args);
});

var pick = function pick(t, args) {
  return t.pick.apply(t, args);
};

function fold(init, f, data) {
  var num_dims = data.shape.length;

  var folder = function folder(accum, indices) {
    var match = num_dims === indices.length;

    if (match) {
      return Curry._3(f, indices, accum, Curry._2(get, data, indices));
    } else {
      var nth_dim = Caml_array.caml_array_get(data.shape, indices.length);
      var stream = Stream.from(function (x) {
        var match = x < nth_dim;

        if (match) {
          return x;
        }
      });
      var _accum = accum;

      while (true) {
        var accum$1 = _accum;
        var i;

        try {
          i = Stream.next(stream);
        } catch (exn) {
          if (exn === Stream.Failure) {
            return accum$1;
          } else {
            throw exn;
          }
        }

        _accum = folder(accum$1, $$Array.append(indices,
        /* array */
        [i]));
        continue;
      }

      ;
    }
  };

  return folder(init,
  /* array */
  []);
}

function iter(data, f) {
  return fold(
  /* () */
  0, function (indices, _acc, v) {
    return Curry._2(f, indices, v);
  }, data);
}

function elem_to_string(t) {
  var match = Dtype.to_kind(Ndarray0.dtype(t));

  switch (match) {
    case
    /* Float32 */
    0:
    case
    /* Float64 */
    1:
      return Pervasives.string_of_float;

    case
    /* Int8_signed */
    2:
      return function (prim) {
        return String(prim);
      };

    case
    /* Int8_unsigned */
    3:
      return function (prim) {
        return String(prim);
      };

    case
    /* Int16_signed */
    4:
      return function (prim) {
        return String(prim);
      };

    case
    /* Int16_unsigned */
    5:
      return function (prim) {
        return String(prim);
      };

    case
    /* Int32 */
    6:
      return Int32.to_string;

    case
    /* Int64 */
    7:
      return Int64.to_string;

    case
    /* Int */
    8:
      return function (prim) {
        return String(prim);
      };

    case
    /* Nativeint */
    9:
      return Nativeint.to_string;

    case
    /* Complex32 */
    10:
      return Pervasives.failwith("Unsupported: Complex32");

    case
    /* Complex64 */
    11:
      return Pervasives.failwith("Unsupported: Complex64");

    case
    /* Char */
    12:
      return function (param) {
        return $$String.make(1, param);
      };
  }
}

function elem_of_string(param) {
  switch (param) {
    case
    /* Float32 */
    0:
      return Caml_format.caml_float_of_string;

    case
    /* Float64 */
    1:
      return Caml_format.caml_float_of_string;

    case
    /* Int8_signed */
    2:
      return Caml_format.caml_int_of_string;

    case
    /* Int8_unsigned */
    3:
      return Caml_format.caml_int_of_string;

    case
    /* Int16_signed */
    4:
      return Caml_format.caml_int_of_string;

    case
    /* Int16_unsigned */
    5:
      return Caml_format.caml_int_of_string;

    case
    /* Int32 */
    6:
      return Caml_format.caml_int32_of_string;

    case
    /* Int64 */
    7:
      return Caml_format.caml_int64_of_string;

    case
    /* Int */
    8:
      return Caml_format.caml_int_of_string;

    case
    /* Nativeint */
    9:
      return Caml_format.caml_nativeint_of_string;

    case
    /* Complex32 */
    10:
      return Pervasives.failwith("Unsupported: Complex32");

    case
    /* Complex64 */
    11:
      return Pervasives.failwith("Unsupported: Complex64");

    case
    /* Char */
    12:
      return function (x) {
        return Caml_string.get(x, 0);
      };
  }
}

function toJs(t) {
  var t$1 = t;
  var size = Ndarray0.size(t$1);
  var dimension = t$1.dimension;
  var shape = t$1.shape;
  var stride = Ndarray0.stride(t$1);
  var offset = Ndarray0.offset(t$1);
  var order = Ndarray0.order(t$1);
  var dtype = Dtype.unwrap(Ndarray0.dtype(t$1));
  var data = Caml_array.caml_make_vect(size, "");
  var elem_to_string$1 = elem_to_string(t$1);
  var cnt = fold(0, function (_indices, i, x) {
    Caml_array.caml_array_set(data, i, Curry._1(elem_to_string$1, x));
    return i + 1 | 0;
  }, t$1);

  if (cnt !== size) {
    Pervasives.failwith("logical error");
  }

  return {
    dimension: dimension,
    shape: shape,
    offset: offset,
    stride: stride,
    dtype: dtype,
    size: size,
    order: order,
    data: data
  };
}

function fromJs(t) {
  var t$1 = t;
  var size = Ndarray0.size(t$1);
  var shape = Ndarray0.shape(t$1);
  var dtype = Ndarray0.dtype(t$1);
  var kind = Dtype.to_kind(dtype);
  var elem_of_string$1 = elem_of_string(kind);
  var src_data = Ndarray0.data(t$1);
  var t$prime = of_kind(Dtype.to_kind(dtype), shape);
  var cnt = fold(0, function (indices, i, _x) {
    var str = Caml_array.caml_array_get(src_data, i);

    Curry._3(set, t$prime, indices, Curry._1(elem_of_string$1, str));

    return i + 1 | 0;
  }, t$prime);

  if (cnt !== size) {
    Pervasives.failwith("logical error");
  }

  return t$prime;
}

var stride = Ndarray0.stride;
var order = Ndarray0.order;
var size = Ndarray0.size;
var offset = Ndarray0.offset;
export { t, stride, create, of_kind, dimension, shape, data, order, size, offset, kind, get, set_unsafe, set, dtype, elem_size_in_bytes, pick, fromJs, toJs, fold, iter };
/* get Not a pure module */